module.exports = __webpack_public_path__ + "src/assets/img/m9.c7a249b4.svg";